__turbopack_context__.v({
  "blue": "Marker-module__JCXOcq__blue",
  "dark": "Marker-module__JCXOcq__dark",
  "gray": "Marker-module__JCXOcq__gray",
  "marker": "Marker-module__JCXOcq__marker",
});
